var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShapesgrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_179274",
    "data-name": "Group 179274",
    transform: "translate(-82 -164)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_146603",
    "data-name": "Rectangle 146603",
    width: 32,
    height: 32,
    rx: 6,
    transform: "translate(82 164)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_117",
    "data-name": "Union 117",
    d: "M7263.166,18490a1.688,1.688,0,0,1-1.673-1.691v-4.213a1.686,1.686,0,0,1,1.673-1.687h4.158a1.686,1.686,0,0,1,1.674,1.688v4.213a1.688,1.688,0,0,1-1.674,1.691Zm-.409-5.9v4.213a.416.416,0,0,0,.409.418h4.158a.416.416,0,0,0,.409-.418v-4.213a.415.415,0,0,0-.409-.414h-4.158A.415.415,0,0,0,7262.757,18484.094Zm-6,5.9a3.8,3.8,0,0,1,0-7.592h.171a3.8,3.8,0,0,1,0,7.592Zm-2.488-3.8a2.511,2.511,0,0,0,2.488,2.523h.167a2.523,2.523,0,0,0,0-5.045h-.167A2.51,2.51,0,0,0,7254.267,18486.2Zm3.212-4.627a.633.633,0,0,1-.63-.635.613.613,0,0,1,.085-.318l3.608-6.326a.642.642,0,0,1,1.08,0l.009.014,3.6,6.316a.653.653,0,0,1,.085.318.633.633,0,0,1-.634.635Zm1.094-1.273h5.021l-2.511-4.4Z",
    transform: "translate(-7162.998 -18301.998)",
    fill: "#1e1e1e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapesgrey);
export default __webpack_public_path__ + "static/media/Shapesgrey.6cb87fe7ee03911d680a4a338f128f3c.svg";
export { ForwardRef as ReactComponent };